import { ParsedUrlQuery } from 'querystring';

export function getPriceMin(query: ParsedUrlQuery) {
    if (query['price_min']) {
        return query['price_min'];
    }

    return '';
}
